/* eslint-disable @typescript-eslint/no-unused-vars */
import { type ColorTheme } from "..";

export const getLightColorTheme = (rtl: boolean): ColorTheme => ({
	name: "Light",
	article: {
		bg: "primary.white",
		color: "primary.dark"
	},
	contentWrapper: {
		bg: "primary.white",
		color: "primary.dark"
	}
});